module.exports = __webpack_public_path__ + "img/107.97d6cec1.svg";